import React, { FC } from 'react';

const LinkIcon: FC = () => {
    return (
        <svg
            className="svg-inline"
            stroke="currentColor"
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.25 9.24996C6.45367 9.45784 6.69678 9.62298 6.96508 9.73572C7.23338 9.84846 7.52148 9.90653 7.8125 9.90653C8.10352 9.90653 8.39162 9.84846 8.65992 9.73572C8.92822 9.62298 9.17133 9.45784 9.375 9.24996L11.875 6.74996C12.2894 6.33556 12.5222 5.77351 12.5222 5.18746C12.5222 4.60141 12.2894 4.03936 11.875 3.62496C11.4606 3.21056 10.8986 2.97775 10.3125 2.97775C9.72645 2.97775 9.1644 3.21056 8.75 3.62496L8.4375 3.93746"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.74999 6.74997C8.54632 6.54209 8.30321 6.37695 8.03491 6.26421C7.76661 6.15147 7.47852 6.0934 7.18749 6.0934C6.89647 6.0934 6.60837 6.15147 6.34007 6.26421C6.07177 6.37695 5.82867 6.54209 5.62499 6.74997L3.12499 9.24997C2.71059 9.66437 2.47778 10.2264 2.47778 10.8125C2.47778 11.3985 2.71059 11.9606 3.12499 12.375C3.53939 12.7894 4.10144 13.0222 4.68749 13.0222C5.27354 13.0222 5.83559 12.7894 6.24999 12.375L6.56249 12.0625"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LinkIcon;
